module.exports = __webpack_public_path__ + "static/media/FiraCode-Regular.dc34dd99.ttf";